export function EmployeeConsentSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/employee-consent.svg'"></ng-include>`
    }
}